import { isDebug } from '@/js/libs/is-debug';
export class DevConsole {
    /* eslint-disable no-console */
    originalError = console.error.bind(console);
    originalWarn = console.warn.bind(console);
    originalLog = console.log.bind(console);
    originalInfo = console.info.bind(console);
    originalDebug = console.debug.bind(console);
    /* eslint-enable no-console */
    isDev = typeof window !== 'undefined' && window?.location?.host
        ? ['dev.', 'localhost', 'dev-cdn.'].some((l) => window.location.host.startsWith(l))
        : false;
    tags = [];
    label = [];
    _counter = 0;
    noop = () => undefined;
    limit = 0;
    constructor(...tags) {
        this.tags = tags;
        this.label = tags.length ? [`%c[${tags.join()}]`, 'color: #034eaf; background-color: #96f9f5; padding: 2px'] : [];
    }
    get logsAllowed() {
        if (!(this.isDev || isDebug()))
            return false;
        if (this.limit && this._counter >= this.limit) {
            const key = `_adnz_${this.tags.join('_')}__resume`;
            // @ts-expect-error - temporary property
            if (!window[key]) {
                this.originalWarn(`Logs limit reached (${this.limit}). Execute ${key}(<new_limit>) for set new limit`);
                // @ts-expect-error - temporary property
                window[key] = (newLimit) => {
                    if (typeof newLimit === 'number') {
                        this.limit = newLimit;
                        // @ts-expect-error - temporary property
                        delete window[key];
                    }
                };
            }
            return false;
        }
        return true;
    }
    get error() {
        return this.originalError.bind(console, ...this.label);
    }
    get warn() {
        if (this.logsAllowed) {
            this._counter++;
            return this.originalWarn.bind(console, ...this.label);
        }
        return this.noop;
    }
    get log() {
        if (this.logsAllowed) {
            this._counter++;
            return this.originalLog.bind(console, ...this.label);
        }
        return this.noop;
    }
    get info() {
        if (this.logsAllowed) {
            this._counter++;
            return this.originalInfo.bind(console, ...this.label);
        }
        return this.noop;
    }
    get debug() {
        if (this.logsAllowed) {
            this._counter++;
            return this.originalDebug.bind(console, ...this.label);
        }
        return this.noop;
    }
    tag(...tags) {
        return new DevConsole(...this.tags, ...tags);
    }
}
console.dev = new DevConsole();
